export default __webpack_public_path__ + "img/ic-jetStar.1b5b09dd.png";